import script from "./Checkboxes.vue?vue&type=script&setup=true&lang=ts"
export * from "./Checkboxes.vue?vue&type=script&setup=true&lang=ts"

import "./Checkboxes.vue?vue&type=style&index=0&id=03db21d5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03db21d5"]])

export default __exports__